export const departmentEnum = [
  {
    label: 'Administrativo',
    value: 'Administrativo',
  },
  { label: 'Comercial', value: 'Comercial' },
  { label: 'CX', value: 'CX' },
  { label: 'Design', value: 'Design' },
  { label: 'Engenharia', value: 'Engenharia' },
  { label: 'RH', value: 'RH' },
  { label: 'Marketing', value: 'Marketing' },
];
